import React, {useContext} from 'react';
import {BalanceSheetContext} from "./BalanceSheetContext";
import NewTabulator from "../../NewTabulator/NewTabulator";
import {formatToPersianAddCommaNegativeToParentheses} from "../../../utils/CommaSeparator";


function TableShow(props) {
  const value = useContext(BalanceSheetContext);
  const setData = value.setData
  const data = value.data.mainData

  const cols = data?.column?.map(v => {
    if (data?.priceFields?.includes(v.field)) {
      v.formatter = (cell) => {
        const temp = formatToPersianAddCommaNegativeToParentheses(cell.getValue())
        return <>{temp}</>
      }
      v.bottomCalc = "sum"
    }
    return v
  })

   
  return (<div>
    <div>
      <NewTabulator
        columns={cols || []}
        data={data?.data || []}
        className={"header__costBenefit2__table"}
      />
    </div>
  </div>)

}

export default TableShow;